import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import TextLink from 'LuxKit/TextLink'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import { useAddedItineraryItem } from 'tripPlanner/assistant/contexts/AddedItineraryItemContext'

const ItineraryLink = styled(TextLink)`
  margin-top: ${rem(8)};
`

/**
 * "See updated itinerary" — the in-chat twin of the added-to-trip snackbar's View action.
 * Both switch to the Timeline and scroll to the item that was added; when a turn added
 * several items, both target the first one.
 *
 * Renders nothing unless this message is the turn that performed the add, and is safe to
 * mount anywhere: the context has a non-throwing default.
 */
function AddedItineraryItemLink({ messageId }: { messageId: string }) {
  const intl = useIntl()
  const { addedItemLink, viewAddedItem } = useAddedItineraryItem()

  if (addedItemLink?.messageId !== messageId) {
    return null
  }

  return (
    <ItineraryLink
      weight="bold"
      size="medium"
      underline
      block
      endIcon={<LineAngleRightIcon />}
      onClick={viewAddedItem}
      data-testid="see-updated-itinerary"
    >
      {intl.formatMessage({
        id: '23Q4NH0T3_glN0AaykxE',
        defaultMessage: 'See updated itinerary',
        description: 'Chat link that opens the Timeline view and scrolls to the item the assistant just added to the trip',
      })}
    </ItineraryLink>
  )
}

export default AddedItineraryItemLink
